import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { FAQS } from '../mock';

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[900px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-14 fade-in">
          <div className="text-sm font-bold tracking-[0.25em] uppercase text-neutral-500 mb-3">FAQ</div>
          <h2 className="text-4xl md:text-5xl font-black text-black mb-4">Frequently Asked Questions</h2>
          <p className="text-lg text-neutral-600">Discover how Xxpand can simplify your business &mdash; see it in action with a free demo.</p>
        </div>

        <div className="space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`fade-in rounded-2xl border transition-all duration-300 ${isOpen ? 'bg-white border-[#22c55e] shadow-[0_10px_30px_-15px_rgba(34,197,94,0.5)]' : 'bg-neutral-50 border-neutral-200 hover:border-neutral-300'}`}
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <button
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                >
                  <span className="text-[16px] md:text-lg font-bold text-black">{f.q}</span>
                  <span className={`flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-[#22c55e]' : 'bg-white border border-neutral-200'}`}>
                    {isOpen ? <Minus className="w-4 h-4 text-black" /> : <Plus className="w-4 h-4 text-black" />}
                  </span>
                </button>
                <div className={`grid transition-all duration-500 ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                  <div className="overflow-hidden">
                    <div className="px-6 pb-6 text-neutral-600 leading-relaxed">{f.a}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
